import { callApi, HttpMethod } from "../../../utils/httpRequest";

export const updateTimecardTemplate = async ({
  userId,
  timeCardTemplateFileKey,
  timeCardTemplateFolderName,
}: {
  userId: string;
  timeCardTemplateFileKey: string;
  timeCardTemplateFolderName: string;
}) => {
  const res = await callApi({
    method: HttpMethod.PUT,
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    url: `${global.api}/facilityprofile/${userId}/time-card-template`,
    body: {
      timeCardTemplateFileKey,
      timeCardTemplateFolderName,
    },
  });

  return res;
};

export const deleteTimecardTemplate = async ({ userId }: { userId: string }) => {
  const res = await callApi({
    method: HttpMethod.DELETE,
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    url: `${global.api}/facilityprofile/${userId}/time-card-template`,
  });

  return res;
};
